module.exports = __webpack_public_path__ + "static/media/12-item-a.647cd2ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/12-item-a.jpg
// module id = 1196
// module chunks = 33